import React from "react";

type Props = {
  title: string;
  children: React.ReactNode;
};

export default function AdminSectionCard({ title, children }: Props) {
  return (
    <section className="app-surface min-w-0 overflow-hidden rounded-[1.75rem] border p-4 sm:rounded-3xl sm:p-6">
      <div className="text-sm font-semibold text-[color:var(--color-page-text)] sm:text-[15px]">
        {title}
      </div>
      <div className="mt-4 min-w-0 sm:mt-5">{children}</div>
    </section>
  );
}
